import {Injectable} from '@tanbo/vue-di-plugin'
import {Http} from '@zhfe/common-library'

export interface MsgYzmRequestParams {
  /** 手机号 */
  phone_number: string
}

export interface MsgYzmResponse {
  /** 发送状态 ("SUCCESS": 成功, "FAILED": 失败) */
  status: string,
  /** 状态描述 */
  message: string,
  /** 下次允许发送的秒数 */
  next_allow_sec: number
}

export interface GetTokenPhoneRequestParams {
  /** 验证凭据 */
  code: string,
  /** 手机号 */
  phone_number: string,
}

export interface GetTokenPhoneResponse {
  /** 接口状态 */
  status: string,
  /** 注销令牌 */
  close_token: string,
  /** 状态描述 */
  message: string
}

export interface DeleteAccountRequestParams {
  /** 注销令牌 */
  close_token: string
}

export interface GetWXCodeResponse {
  /** 二维码地址 */
  qrcode_url: string
  /** 验证标识 */
  verify_ticket: string
  /** 过期时间（毫秒） */
  expire_seconds: number
}

export interface GetTokenWXRequestParams {
  /** 验证凭证 (由获取二维码接口返回) */
  verify_ticket: string
}

export interface GetTokenWXResponse {
  /** 接口状态 */
  status: string,
  /** 注销令牌 */
  close_token: string,
  /** 状态描述 */
  message: string
}

/** 发送验证码错误状态码 */
export enum err_ret_info {
  often = 4572002, /** 短信发送频繁 */
  max = 4572007 /** 超过最大发送次数 */
}

@Injectable()
export class AccountManageLoginService {
  constructor(private http: Http) {
  }

  /**
   * @description 请求获取短信验证码
   */
  requestGetMsgYzm (params: MsgYzmRequestParams): Promise<MsgYzmResponse> {
    return this.http.post('/account/close/send_sms', params)
  }

  /**
   * @description 验证手机验证码并获取令牌
   */
  requestGetTokenPhone (params: GetTokenPhoneRequestParams): Promise<GetTokenPhoneResponse> {
    return this.http.post('/account/close/verify_sms', params)
  }

  /** 
   * @description 确认注销账号
   */
  requestDeleteAccount (params: DeleteAccountRequestParams) {
    return this.http.post('/account/close/confirm', params)
  }

  /**
   * @description 获取注销验证二维码 (微信扫码模式专用)
   */
  requestGetWXCode (): Promise<GetWXCodeResponse> {
    return this.http.post('/account/close/get_wx_verify_qrcode', {})
  }

  /**
   * @description 确认微信验证状态并获取令牌 (支持长轮询)
   */
  requestGetTokenWX (params: GetTokenWXRequestParams): Promise<GetTokenWXResponse> {
    return this.http.post('/account/close/confirm_wx_verify', params)  
  }
}
